import React from 'react';

export default function SecurityEmptyState({ title, lead = null }) {
  return (
    <div className="vx-sec-empty">
      <p className="vx-sec-empty-title">{title}</p>
      {lead ? <p className="vx-sec-empty-lead">{lead}</p> : null}
    </div>
  );
}
